export { default } from "./Quantity";
